export const DEFAULT_ENVIRONMENT = {
  channelCode: 'DGX',
  countryCode: 'GB',
  requestSource: 'DandGUK',
  requestAction: 'MyAccount',
};
